import {resizeCanvasToDisplaySize} from "../utils/canvasUtils"
import {InputManager} from "./InputManager";
import {Camera} from "./Camera";

export class InteractiveCanvas
{
    canvas:HTMLCanvasElement
    ctx:CanvasRenderingContext2D
    input: InputManager;
    camera: Camera;

    constructor(elementSelector = "canvas",cameraOptions = {}) {

        this.canvas = document.querySelector(elementSelector) as HTMLCanvasElement
        this.ctx = this.canvas.getContext('2d')
        this.input = new InputManager(this.canvas)
        this.camera = new Camera(cameraOptions)
    }

    autoResize()
    {
        resizeCanvasToDisplaySize(this.canvas)
    }

    prepareForRender() {

        this.camera.activate(this.ctx)
    }
}
